module.exports = __webpack_public_path__ + "media/images/flags/16/Commonwealth-0a076e53e96aa4c3ae274779a459ea1b.png";